export const resolveCJDRMake = (modelName = "") => {
  const name = modelName.toLowerCase();

  if (name.includes("jeep")) return "Jeep";
  if (name.includes("wagoneer")) return "Jeep";
  if (name.includes("dodge")) return "Dodge";
  if (name.includes("chrysler")) return "Chrysler";
  if (name.includes("ram")) return "RAM";

  return "CJDR";
};